import { useEffect, useState } from 'react';

export const useParentPageState = () => {
  const [parentPageId, setParentPageID] = useState<string>(null);
  const [parentPageUrl, setParentPageUrl] = useState<string>(null);

  useEffect(() => {
    // QuoteOriginPageId is set in the parent page of this form. When enquiry type form is rendered in multiple tabs at the same time,
    // it is required to maintian state individual to each tab/component. The state is maintianed in react component and also in session
    // storage in case the page reloads/refreshes.
    const parentId = localStorage.getItem('quoteOriginPageID') || null;
    const sessionParentId = sessionStorage.getItem('quoteOriginPageID') || null;
    const parentUrl = localStorage.getItem('quoteOriginPageUrl') || null;
    const sessionParentUrl = sessionStorage.getItem('quoteOriginPageUrl') || null;
    const isReloadEvent =
      (window.performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming)
        ?.type === 'reload';

    // update parentId from local storage if state does not have parentPageId already
    if (parentId && !parentPageId) {
      setParentPageID(parentId);
      sessionStorage.setItem('quoteOriginPageID', parentId);
      localStorage.removeItem('quoteOriginPageID');
    } else if (sessionParentId && !parentId) {
      if (isReloadEvent) {
        // use the session storage data only in case of page reload event.
        setParentPageID(sessionParentId);
      } else {
        // clear the session storage for other types of navigation other than reload
        sessionStorage.removeItem('quoteOriginPageID');
      }
    }

    if (parentUrl && !parentPageUrl) {
      setParentPageUrl(parentUrl);
      sessionStorage.setItem('quoteOriginPageUrl', parentUrl);
      localStorage.removeItem('quoteOriginPageUrl');
    } else if (sessionParentUrl && !parentUrl) {
      // use the session storage data only in case of page reload event.
      if (isReloadEvent) {
        setParentPageUrl(sessionParentUrl);
      } else {
        // clear the session storage for other types of navigation other than reload
        sessionStorage.removeItem('quoteOriginPageUrl');
      }
    } else {
      setParentPageUrl(window.location.href);
    }

    const handlePopState = () => {
      window.location.reload();
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  return { parentPageId, parentPageUrl };
};

export const useOnSubmitError = () => {
  const [formSubmitError, setFormSubmitError] = useState<string | boolean>(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setFormSubmitError(false);
    }, 2000);

    return () => {
      clearTimeout(timeout);
    };
  }, [formSubmitError]);

  return [formSubmitError, setFormSubmitError] as const;
};
